// SUPER-LOT 108 — logique pure du Dashboard CASH RJ (multi-banques), extraite pour être testable sans Supabase.
export const nk = (s) => String(s || "").replace(/\s+/g, "").toUpperCase();
export const toNum = (v) => {
    let s = String(v ?? "").replace(/[\s\u202f\u00a0]/g, "");
    if (s.includes(",")) s = s.replace(/\./g, "").replace(",", ".");  // format FR : « 1 234,56 » → 1234.56
    const n = Number(s.replace(/[^\d.-]/g, ""));
    return Number.isNaN(n) ? 0 : n;
};
// Solde prévisionnel : on provisionne les lignes ni payées, ni annulées, ni en stand-by (à demander + acceptées AJ).
export const isPending = (r) => !r.statut_paye && !r.statut_annule && !r.statut_stand_by;
// ADDENDUM 2 LOT 129 — « Virements demandés » = À demander OU Accepté AJ ; « En attente » = statut_stand_by.
export const isDemande = (r) => !!(r.statut_a_demander || r.statut_accepte_aj);
export const isEnAttente = (r) => !!r.statut_stand_by && !r.statut_paye && !r.statut_annule;

// Routage par IBAN débiteur : chaque ligne est affectée à une banque via nk(iban_debiteur).
// Les lignes pending sans IBAN débiteur tombent dans « ⚠️ Dépenses non affectées ».
// SUPER-LOT 131 — Virements internes (net) par banque : −débit (iban_source) / +crédit (iban_cible),
// uniquement pour les lignes « À demander » ou « Accepté AJ ». Somme globale = 0 (nivellement neutre).
export function internesNet(internes, key) {
    if (!key) return 0;
    const dem = (internes || []).filter((v) => isDemande(v) && nk(v.iban_source) && nk(v.iban_cible));
    const credit = dem.filter((v) => nk(v.iban_cible) === key).reduce((s, v) => s + toNum(v.montant), 0);
    const debit = dem.filter((v) => nk(v.iban_source) === key).reduce((s, v) => s + toNum(v.montant), 0);
    return credit - debit;
}

export function computeDashboard(banques, soldes, virements, recurrents, internes) {
    const rows = (banques || []).map((b) => {
        const key = nk(b.iban);
        const vir = [
            ...(virements || []).filter((v) => key && nk(v.iban_debiteur) === key && isDemande(v)),
            ...(recurrents || []).filter((r) => key && nk(r.iban_debiteur) === key && isDemande(r)),
        ].reduce((s, x) => s + toNum(x.montant), 0);
        const attente = (recurrents || []).filter((r) => key && nk(r.iban_debiteur) === key && isEnAttente(r)).reduce((s, r) => s + toNum(r.montant), 0);
        const net = internesNet(internes, key);
        const reel = toNum((soldes || {})[key]);
        return { key, banque: b.banque || "Banque", iban: b.iban || "", devise: b.devise || "EUR", reel, vir, attente, net, prev: reel - vir - attente + net, hasIban: !!key };
    });
    const vir0 = [
        ...(virements || []).filter((v) => !nk(v.iban_debiteur) && isDemande(v)),
        ...(recurrents || []).filter((r) => !nk(r.iban_debiteur) && isDemande(r)),
    ].reduce((s, x) => s + toNum(x.montant), 0);
    const att0 = (recurrents || []).filter((r) => !nk(r.iban_debiteur) && isEnAttente(r)).reduce((s, r) => s + toNum(r.montant), 0);
    return { rows, unaffected: { vir: vir0, attente: att0, total: vir0 + att0 }, totalPrev: rows.reduce((s, r) => s + r.prev, 0) };
}
